import { DatepickerModel } from '$views/RecommendationsForms/ResidenceForm/DateStep/DateStep.model'
import { isADateAfter1HourFromNow, formatDateAndHourToDate } from '$utils/dateFormatter'

export const validateDay = (day: DatepickerModel) => {
  const completeHours = day.hours.filter(hour => hour.duration && hour.start)
  if (completeHours.length !== day.hours.length) {
    return 'Indica la fecha y hora'
  }

  const hoursAfter1hourFromNow = completeHours.filter(hour =>
    isADateAfter1HourFromNow(formatDateAndHourToDate(day.date, hour.start)),
  )
  if (hoursAfter1hourFromNow.length !== completeHours.length) {
    return 'Indica una fecha y una hora posteriores a la fecha y hora actuales (min 1h más tarde)'
  }

  return ''
}

export const validateAllDays = (days: DatepickerModel[]) => {
  if (days.length === 0) {
    return false
  }
  const errorDays = days.filter(day => (validateDay(day) === '' ? false : true))
  if (errorDays.length > 0) {
    return false
  }

  return true
}



// WEBPACK FOOTER //
// ./src/views/RecommendationsForms/ResidenceForm/DateStep/DateStep.validator.ts